import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 英文翻译
const enTranslations = {
  common: {
    loading: 'Loading...',
    create: 'Create',
    workflow: 'Workflow',
    error: {
      loading: 'Failed to load'
    }
  },
  workflow: {
    title: 'Workflow',
    empty: 'No workflows yet',
    untitled: 'Untitled Workflow',
    no: {
      description: 'No description',
      date: 'No date'
    },
    status: {
      published: 'Published',
      draft: 'Draft',
    },
    editor: {
      settings: 'Settings',
      statistics: 'Statistics',
      nodes: 'Nodes',
      connections: 'Connections',
      general: 'General',
      name: 'Name',
      namePlaceholder: 'Enter workflow name',
      description: 'Description',
      descriptionPlaceholder: 'Enter workflow description',
      advanced: 'Advanced',
      enableDebugMode: 'Enable Debug Mode',
      autoSave: 'Auto Save',
    }
  },
};

// 中文翻译
const zhTranslations = {
  common: {
    loading: '加载中...',
    create: '创建',
    workflow: '工作流',
    error: {
      loading: '加载失败'
    }
  },
  workflow: {
    title: '工作流',
    empty: '暂无工作流',
    untitled: '未命名工作流',
    no: {
      description: '暂无描述',
      date: '暂无日期'
    },
    status: {
      published: '已发布',
      draft: '草稿',
    },
    editor: {
      settings: '设置',
      statistics: '统计',
      nodes: '节点',
      connections: '连接',
      general: '常规',
      name: '名称',
      namePlaceholder: '输入工作流名称',
      description: '描述',
      descriptionPlaceholder: '输入工作流描述',
      advanced: '高级',
      enableDebugMode: '启用调试模式',
      autoSave: '自动保存',
    }
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enTranslations.common,
        workflow: enTranslations.workflow,
      },
      zh: {
        common: zhTranslations.common,
        workflow: zhTranslations.workflow,
      },
    },
    ns: ['common', 'workflow'],
    defaultNS: 'common',
    lng: 'zh', // 默认语言
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 